import { forwardRef } from 'react';
import cx from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultStyles = {
  position: 'absolute',
  backgroundColor: 'white',
  color: '#666666',
  padding: '0.3rem 0.5rem',
  borderRadius: '3px',
  fontSize: '14px',
  boxShadow: '0 1px 2px rgba(33,33,33,0.2)',
  lineHeight: '1em',
  pointerEvents: 'none'
};
const Tooltip = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    top,
    left,
    offsetLeft = 10,
    offsetTop = 10,
    style = defaultStyles,
    children,
    unstyled = false,
    applyPositionStyle = false,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: cx('visx-tooltip', className),
    style: {
      top: top == null || offsetTop == null ? top : top + offsetTop,
      left: left == null || offsetLeft == null ? left : left + offsetLeft,
      ...(applyPositionStyle && {
        position: 'absolute'
      }),
      ...(!unstyled && style)
    },
    ...restProps,
    children: children
  });
});
Tooltip.displayName = 'Tooltip';
export default Tooltip;